import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcoAiRobot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="17"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.3846 22.9017H43.0472C41.6613 16.7084 36.1297 12.0574 29.5256 12.0574H25.3077V10.5152C27.4046 9.76811 28.9231 7.77999 28.9231 5.43041C28.9231 2.44222 26.4887 0.00828959 23.5 0.00828959C20.5113 0.00828959 18.0769 2.44222 18.0769 5.43041C18.0769 7.77999 19.5954 9.76811 21.6923 10.5152V12.0574H17.4744C10.8703 12.0574 5.33872 16.7084 3.95282 22.9017H3.61538C1.62692 22.9017 0 24.5283 0 26.5164V30.1312C0 32.1193 1.62692 33.7459 3.61538 33.7459H4.27821C5.70026 38.18 9.29154 41.6261 13.7987 42.8792C13.4613 43.5901 13.2564 44.3612 13.2564 45.1926C13.2564 46.1927 14.0638 47 15.0641 47H31.9359C32.9362 47 33.7436 46.1927 33.7436 45.1926C33.7436 44.3612 33.5387 43.578 33.2013 42.8792C37.7085 41.6381 41.2997 38.18 42.7218 33.7459H43.3846C45.3731 33.7459 47 32.1193 47 30.1312V26.5164C47 24.5283 45.3731 22.9017 43.3846 22.9017ZM23.5 3.62304C24.5003 3.62304 25.3077 4.43033 25.3077 5.43041C25.3077 6.43049 24.5003 7.23778 23.5 7.23778C22.4997 7.23778 21.6923 6.43049 21.6923 5.43041C21.6923 4.43033 22.4997 3.62304 23.5 3.62304ZM29.5256 39.7705H17.4744C11.8223 39.7705 7.23077 35.1798 7.23077 29.5287V25.914C7.23077 20.2629 11.8223 15.6722 17.4744 15.6722H29.5256C35.1777 15.6722 39.7692 20.2629 39.7692 25.914V29.5287C39.7692 35.1798 35.1777 39.7705 29.5256 39.7705Z"
      fill="#6C6B6B"
    />
    <path
      d="M16.8718 20.4919C14.8833 20.4919 13.2564 22.1185 13.2564 24.1066V27.7213C13.2564 29.7095 14.8833 31.3361 16.8718 31.3361C18.8603 31.3361 20.4872 29.7095 20.4872 27.7213V24.1066C20.4872 22.1185 18.8603 20.4919 16.8718 20.4919Z"
      fill="#6C6B6B"
    />
    <path
      d="M30.1282 20.4919C28.1397 20.4919 26.5128 22.1185 26.5128 24.1066V27.7213C26.5128 29.7095 28.1397 31.3361 30.1282 31.3361C32.1167 31.3361 33.7436 29.7095 33.7436 27.7213V24.1066C33.7436 22.1185 32.1167 20.4919 30.1282 20.4919Z"
      fill="#6C6B6B"
    />
  </svg>
);
export default SvgIcoAiRobot;
